module.exports = __webpack_public_path__ + "static/media/markPaymentIcon.4a8622b7.svg";